<template>
    <b-modal
        :id="id"
        title="Import Data"
        centered
        no-close-on-backdrop
        @hidden="close"
    >
        <b-form-group label="CSV file">
            <b-form-file
                id="file-small"
                v-model="file"
                size="sm"
                accept=".csv"
                @change="onChange"
            />
        </b-form-group>

        <div class="import-csv-modal">
            <div class="errors-box">
                <div
                    v-for="(error, index) in errors"
                    :key="index"
                    class="single-error"
                >
                    {{ error }}
                </div>
            </div>
            <div v-if="response" class="response-box">
                <div class="success">
                    <span>Success: {{ response.success }} </span>
                </div>
                <div class="failed">
                    <span> Failed: {{ response.fail }} </span>
                </div>
                <div v-if="response.skipped">
                    <span>Skippped: {{ response.skipped }} </span>
                </div>
                <div v-if="response.created">
                    <span> Created: {{ response.created }} </span>
                </div>
                <div v-if="response.updated">
                    <span>Updated: {{ response.updated }} </span>
                </div>
            </div>
        </div>

        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn-danger waves-effect waves-light mr-2"
                    @click="close"
                >
                    Close
                </button>
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    :disabled="!file || inProcess"
                    @click="importFile"
                >
                    Agree
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { startCase } from 'lodash';
import { StatusCodes as HTTP } from 'http-status-codes';

export default {
    props: {
        path: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: false,
            default: 'import-csv'
        }
    },

    data() {
        return {
            file: null,
            serverErrors: [],
            response: null,
            inProcess: false
        };
    },

    computed: {
        errors() {
            if (this.response?.failMessages) {
                return this.response.failMessages || [];
            }

            if (!this.serverErrors.length) {
                return [];
            }

            const errors = this.serverErrors.map(({ message, param }) => {
                const [, index, , property] = param.split(/\[|\]|\./);

                return `${startCase(property)} in row ${index}: ${message}`;
            });

            return errors;
        }
    },

    methods: {
        ...mapActions({
            importCsv: 'filesHelper/importCsv'
        }),

        async importFile() {
            this.inProcess = true;
            this.serverErrors = [];
            this.response = null;

            try {
                this.response = await this.importCsv({
                    path: this.path,
                    file: this.file
                });

                this.$emit('imported');
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            } finally {
                this.inProcess = false;
            }
        },

        close() {
            this.file = null;
            this.serverErrors = [];
            this.response = null;
            this.$bvModal.hide(this.id);
        },

        onChange() {
            this.serverErrors = [];
            this.response = null;
        }
    }
};
</script>
